import script from "./headlineContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./headlineContainer.vue?vue&type=script&setup=true&lang=js"

import "./headlineContainer.vue?vue&type=style&index=0&id=c09f1808&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c09f1808"]])

export default __exports__